import React, { useEffect, useContext, useState } from "react"
import { masDias, HOY, toInput, toOutput, lunesSemana, sumHoras, Sfiltro, Sfiltros, SetiquetaFiltro, SinputFiltro, SfotoFiltro } from "./general";
import { AppContext } from "./index";
import ListaOpciones from "./ListaOpciones";
import HorasProyecto from "./HorasProyecto"
import HorasIncidentes from "./HorasIncidentes";
import HorasTotales from "./HorasTotales";

export default function UtilizacionPusuario() {

    let { firebase, usrLogged } = useContext(AppContext);
    let color = ["#FE642E"];

    const [persona, setPersona] = useState(usrLogged.id);
    const [inicio, setInicio] = useState(toInput(lunesSemana(masDias(HOY, -30))));
    const [fin, setFin] = useState(toInput(lunesSemana(masDias(HOY, 30))));
    const [horasP, setHorasP] = useState({}) // horas x proyecto
    const [horasI, setHorasI] = useState([]) // horas totales a incidentes
    const [horasPersona, setHorasPersona] = useState({}) // horas totales por persona (persona === "Todas")
    const [horas, setHoras] = useState([])   // horas totales sin discriminar proyectos/incidentes
    const [indHoy, setIndHoy] = useState(undefined)

    useEffect(() => {
        let indiceHOY = firebase.horasIncurridas(lunesSemana(toOutput(inicio)), lunesSemana(toOutput(fin)), "Todos", "Todos", persona, inicio, fin)
        setHorasP(firebase.horasProyecto)
        setHorasI(firebase.totalHorasIncidentes)
        setHoras(firebase.totalHoras)
        setHorasPersona(firebase.horasPersona)
        setIndHoy(indiceHOY)

    }, [firebase, persona, inicio, fin]);

    function LineaTiempo() {
        return (
            <div style={SlineaTiempo} >
                {horasI.map((_, ind) => (
                    <div style={{ ...SceldaTiempo, background: ind >= indHoy ? "#a4a4a4" : "#212121" }} key={ind}>
                        {ind === indHoy ? "HOY" : `s${ind}`}
                    </div>)
                )}
            </div>)
    }

    return (
        <div style={{ width: "100%" }}>
            <div style={{ ...Sfiltros, marginLeft: "20px" }} >
                <div style={Sfiltro}>
                    <div style={SetiquetaFiltro} >Persona:</div>
                    <div style={SfotoFiltro} >
                        {persona && <img src={persona !== "Todas" ? firebase.usuario(persona).url : null} alt={"?"} height="35px" width="35px"></img>}
                    </div>
                    <div id="UTPpersona" style={{ ...SinputFiltro, width: "18vw", marginLeft: "10px" }} >
                        {persona && (persona !== "Todas" ? firebase.usuario(persona).nombre : "Todas")}
                    </div>
                </div>
                <div style={Sfiltro}>
                    <div style={SetiquetaFiltro} >Inicio:</div>
                    <input id="UTPinicio" style={{ ...SinputFiltro, width: "11vw" }} type="date"
                        value={inicio}
                        onChange={(e) => {
                            e.persist();
                            setInicio(toInput(lunesSemana(toOutput(e.target.value))));
                        }}>
                    </input>
                </div>
                <div style={Sfiltro}>
                    <div style={SetiquetaFiltro} >Fin:</div>
                    <input id="UTPfin" style={{ ...SinputFiltro, width: "11vw" }} type="date"
                        value={fin}
                        onChange={(e) => {
                            e.persist();
                            setFin(toInput(lunesSemana(toOutput(e.target.value))));
                        }}>
                    </input>
                </div>
                <ListaOpciones setFiltro={setPersona} lista={firebase.filtroPersonas} elemento="UTPpersona" titulo={"Persona"} />
            </div >

            <LineaTiempo />
            <div id="UTPplan" style={{ width: "100%", margin: "5px 20px 20px 20px" }}>
                <div style={SlineaHoras} >
                    {sumHoras(horas) && <HorasTotales horas={horas} horasSemana={(persona && persona !== "Todas") ? firebase.usuario(persona).horassemana : firebase.totalHorasDisponibles} indHoy={indHoy} />}
                </div>

                {persona && persona === "Todas" &&
                    <div style={ShorasPersona}>
                        {Object.keys(horasPersona).map((p, ind) => (
                            <div style={SlineaHoras} key={p}>
                                {<HorasProyecto nombre={firebase.usuario(p).nombre} horas={horasPersona[p]} horasSemana={firebase.usuario(p).horassemana} color={"#F7FE2E"} indHoy={indHoy} />}
                            </div>)
                        )}
                    </div>
                }

                {persona && persona !== "Todas" &&
                    <div style={ShorasPersona}>
                        {Object.keys(horasP).map((p, ind) => (
                            <div style={SlineaHoras} key={p}>
                                {sumHoras(horasP[p]) && <HorasProyecto nombre={firebase.proyecto(p).nombre} horas={horasP[p]} horasSemana={firebase.usuario(persona).horassemana} color={color[ind % color.length]} indHoy={indHoy} />}
                            </div>)
                        )}
                        <div style={SlineaHoras} >
                            {sumHoras(horasI) && <HorasIncidentes horas={horasI} horasSemana={firebase.usuario(persona).horassemana} indHoy={indHoy} />}
                        </div>
                    </div>
                }
            </div>
        </div>)
}

const ShorasPersona = {
    background: "#EFFBFB",
    height: "58vh",
    overflowY: "auto",
    position: "relative",
    paddingTop: "15px"
}
const SlineaHoras = {
    position: "relative",
    marginBottom: "25px",
}

const SlineaTiempo = {
    display: "flex",
    flexDirection: "row",
    height: "3vh",
    width: "100%",
    margin: "25px 20px 15px 20px"
}
const SceldaTiempo = {
    border: "solid 1px white",
    height: "2.5vh",
    fontSize: "1.5vh",
    color: "white",
    textAlign: "center",
    padding: "auto",
    width: "100%"
}